import React from 'react'
import {
    createBrowserRouter,
    createRoutesFromElements,
    Route,
    RouterProvider,
    Navigate,
    useLocation,
} from 'react-router-dom'

import Home from 'page/Home/index'
import AboutUs from 'page/AboutUs/index'
import OurServices from 'page/OurServices/index'
import OurStrength from 'page/OurStrength/index'
import ContactUs from 'page/ContactUs/index'
import Main from 'page/Main'

function LegacyHomeRedirect() {
    const { search } = useLocation()

    return <Navigate to={{ pathname: '/', search }} replace />
}

const router = createBrowserRouter(
    createRoutesFromElements(
        <>
            <Route path='/' element={<Main />}>
                <Route index element={<Home />} />
                <Route path='home' element={<LegacyHomeRedirect />} />
                <Route path='about-us' element={<AboutUs />} />
                <Route path='our-services' element={<OurServices />} />
                <Route path='our-strength' element={<OurStrength />} />
                <Route path='contact-us' element={<ContactUs />} />
            </Route>
        </>,
    ),
)

export default function App() {
    return <RouterProvider router={router} />
}
